import React from 'react';
import { NavLink } from 'reactstrap';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import classNames from 'classnames';

import AccountStore from '../../../store/AccountStore';
import { modelOf } from '../../../prop-types';
import AccountModalTab from '../../../types/AccountModalTab';

const AccountModalLink = ({ accountStore, tab, className, children }) => {
  const toggle = () => {
    accountStore.accountModal.setTab(tab);
    accountStore.accountModal.toggle();
  };

  return (
    <span className="AccountModalLink">
      <NavLink onClick={toggle} href="#" className={classNames(className)}>
        {children}
      </NavLink>
    </span>
  );
};

AccountModalLink.propTypes = {
  accountStore: modelOf(AccountStore).isRequired,
  tab: PropTypes.oneOf(Object.values(AccountModalTab)).isRequired,
  className: PropTypes.string
};

export default inject('accountStore')(observer(AccountModalLink));
